import React, { useEffect, useState } from 'react';
import { FiArrowRight, FiArrowUpRight, FiCheck, FiMail } from 'react-icons/fi';
import { RiOpenaiFill } from 'react-icons/ri';
import { FaLinkedinIn } from 'react-icons/fa6';
import {
  SiAnthropic,
  SiClaude,
  SiFacebook,
  SiGithubcopilot,
  SiGooglegemini,
  SiInstagram,
  SiPerplexity,
  SiWhatsapp,
  SiYoutube,
} from 'react-icons/si';
import { LuAward } from 'react-icons/lu';
import Footer from '../components/layout/Footer';
import MediaLibrary from '../components/sections/MediaLibrary';
import LogoWall from '../components/sections/LogoWall';
import { youtubeChannel } from '../data/media';
import heroPortrait from '../assets/portrait-hero.jpg';
import hrdBadge from '../assets/hrd-corp-accredited-trainer.png';
import profilePortrait from '../assets/portrait-speaking.jpg';
import workshopPhoto from '../assets/training-workshop.jpg';
import botsifyLogo from '../assets/logos/botsify.png';
import reachowlLogo from '../assets/logos/reachowl.png';
import dotomatLogo from '../assets/logos/dotomat.png';
import screenWithMeLogo from '../assets/logos/screenwithme.png';
import aureaLogo from '../assets/logos/aurea.jpg';
import vortechsLogo from '../assets/logos/vortechs.jpg';

function MoonshotIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M14.8 3.2a8.9 8.9 0 1 0 6 14.9A7.4 7.4 0 0 1 14.8 3.2Z" />
      <circle cx="17.5" cy="6.5" r="1.8" />
    </svg>
  );
}

const socialUrls = {
  linkedin: 'https://uk.linkedin.com/in/usamanoman',
  youtube: 'https://www.youtube.com/@botsify',
  facebook: 'https://web.facebook.com/usamathefounder',
  instagram: 'https://www.instagram.com/usamathefounder/',
  email: 'mailto:usama@botsify.com',
};

const teachFloatingTools = [
  { name: 'OpenAI', Icon: RiOpenaiFill, color: '#10A37F' },
  { name: 'Claude', Icon: SiClaude, color: '#D97757' },
  { name: 'Anthropic', Icon: SiAnthropic, color: '#C15F3C' },
  { name: 'Moonshot', Icon: MoonshotIcon, color: '#6366F1' },
  { name: 'Gemini', Icon: SiGooglegemini, color: '#4285F4' },
  { name: 'Perplexity', Icon: SiPerplexity, color: '#20808D' },
  { name: 'Copilot', Icon: SiGithubcopilot, color: '#7C3AED' },
];

const buildFloatingTools = [
  { name: 'LinkedIn', Icon: FaLinkedinIn, color: '#0A66C2', href: socialUrls.linkedin },
  { name: 'YouTube', Icon: SiYoutube, color: '#FF0000', href: socialUrls.youtube },
  { name: 'Facebook', Icon: SiFacebook, color: '#1877F2', href: socialUrls.facebook },
  { name: 'Instagram', Icon: SiInstagram, color: '#E4405F', href: socialUrls.instagram },
  { name: 'WhatsApp', Icon: SiWhatsapp, color: '#25D366' },
  { name: 'Email', Icon: FiMail, color: '#38BDF8', href: socialUrls.email },
];

const bookingUrl = 'https://tidycal.com/usama1/30-minute-meeting';
const trainingEnquiry = bookingUrl;
const speakingEnquiry = bookingUrl;
const consultingCall = bookingUrl;

const tracks = {
  teach: { label: 'Training & Speaking', short: 'Training', cta: 'Discuss a training', href: trainingEnquiry },
  build: { label: 'Consulting & Automation', short: 'Consulting', cta: 'Book a consulting call', href: consultingCall },
};

const programmes = [
  { no: '01', title: 'AI fluency for business teams', outcome: 'Shared language, safe habits and useful starting points for everyday AI use.', audience: 'Teams starting out' },
  { no: '02', title: 'Generative AI in daily work', outcome: 'Prompting, research, drafting and review techniques applied to real tasks.', audience: 'Knowledge workers & team leads' },
  { no: '03', title: 'AI agents & workflow automation', outcome: 'Identify and prototype a low-risk automation opportunity in a real process.', audience: 'Operations & process owners' },
  { no: '04', title: 'AI adoption for leaders', outcome: 'Prioritise opportunities and decide what should remain human.', audience: 'Managers & leadership' },
];

const teachOutcomes = [
  ['1. Syllabus & HRD Corp Docs', 'We tailor the AI training modules to your team and provide the course outline, Accredited Trainer profile (ID: 72369) and quotation.'],
  ['2. e-TRiS Grant Submission', 'Your HR or L&D team submits the grant application on the HRD Corp e-TRiS portal with our complete, ready-to-file documentation.'],
  ['3. Training Delivery & Claim', 'We deliver the hands-on AI workshop for your team and provide attendance and evaluation records for smooth HRD Corp levy claim completion.'],
];

const teachProcess = [
  ['Discover', 'A focused consultation on your team’s current tools, roles and goals.'],
  ['Tailor', 'Custom exercises and prompts drawn from your actual business workflows.'],
  ['Deliver', 'Interactive, hands-on training sessions focused on practical execution.'],
  ['Follow through', 'Templates, playbooks and next steps your team can apply immediately.'],
];

const buildExamples = [
  'Lead follow-up and appointment booking',
  'Customer support and AI chatbot flows',
  'CRM updates and prospect warm-up',
  'Meeting confirmations and reminders',
  'Cross-platform tool integrations',
  'Automated reporting and data sync',
];

const buildProcess = [
  ['Find the friction', 'Map the work that repeats, stalls or moves manually between people and tools.'],
  ['Design the system', 'Choose the right mix of workflow logic, integrations and AI judgement.'],
  ['Build and test', 'Create a focused working system around the real process and its exceptions.'],
  ['Enable the team', 'Document it, train the people involved and improve it with real feedback.'],
];

const experienceItems = [
  {
    years: '2025–Present',
    org: 'DOTOMAT SDN. BHD.',
    location: 'Kuala Lumpur, Malaysia',
    logo: dotomatLogo,
    monogram: 'DT',
    url: 'https://dotomat.com/',
    role: 'Founder & Lead AI Trainer',
    detail: 'HRD Corp accredited corporate AI training, Claude workspace productivity and business workflow automation.',
  },
  {
    years: '2016–Present',
    org: 'Botsify Inc',
    location: 'Kuala Lumpur · United States',
    logo: botsifyLogo,
    monogram: 'B',
    url: 'https://botsify.com',
    role: 'Founder & Chief Executive Officer',
    detail: 'Founded one of the leading no-code AI chatbot and agent platforms; featured in Product Hunt, VentureBeat and Tech in Asia.',
  },
  {
    years: '2023–Present',
    org: 'ReachOwl',
    location: 'Global SaaS',
    logo: reachowlLogo,
    monogram: 'RO',
    url: 'https://reachowl.com',
    role: 'Founder',
    detail: 'Built a multi-channel social outreach and automated CRM prospecting platform from the ground up.',
  },
  {
    years: '2024–Present',
    org: 'Vocallify & ScreenWith.me',
    location: 'Global SaaS',
    logo: screenWithMeLogo,
    monogram: 'VS',
    url: 'https://screenwith.me',
    role: 'Founder & Product Builder',
    detail: 'AI voice agents for automated lead qualification and appointment booking, plus real-time screen collaboration tools.',
  },
  {
    years: '2020–2021',
    org: 'WarmupYourEmail',
    location: 'Acquired by Mailshake',
    logo: null,
    monogram: 'WY',
    url: null,
    role: 'Founder & Chief Executive Officer',
    detail: 'Created an email deliverability and domain warm-up SaaS from scratch and successfully sold the company to Mailshake.',
  },
  {
    years: '2015',
    org: 'Aurea Software',
    location: 'Austin, Texas',
    logo: aureaLogo,
    monogram: 'AS',
    url: null,
    role: 'Software Engineer (Web)',
    detail: 'Engineered enterprise data extraction and transformation pipelines within the Lyris Professional Services team.',
  },
  {
    years: '2014–2016',
    org: 'Vortechs Innovations',
    location: 'Karachi',
    logo: vortechsLogo,
    monogram: 'VI',
    url: null,
    role: 'Co-Founder & Web Engineer',
    detail: 'Co-founded a digital engineering agency delivering full-stack web products and platforms for international clients.',
  },
];

const certifications = [
  {
    id: 'hrd-corp',
    title: 'HRD Corp Accredited Trainer',
    year: 'Accredited',
    issuer: 'HRD Corp Malaysia (Pembangunan Sumber Manusia Berhad)',
    detail: 'Certified corporate trainer for HRD Corp claimable AI & automation programmes.',
    credentialId: 'Trainer ID: 72369',
    badgeImage: hrdBadge,
    Icon: null,
    url: null,
  },
  {
    id: 'anthropic-workflows',
    title: 'Building Personal AI Workflows',
    year: '2026',
    issuer: 'Anthropic',
    detail: 'Claude Projects, context engineering, agentic workflows & workspace automation.',
    credentialId: 'ID: ANTH-YNVPBGRP',
    badgeImage: null,
    Icon: SiAnthropic,
    url: null,
  },
  {
    id: 'openai-agents',
    title: 'Agents and Workflows',
    year: '2026',
    issuer: 'OpenAI',
    detail: 'Autonomous AI agents, tool orchestration & multi-step production workflows.',
    credentialId: 'ID: tc9rxyhi8d',
    badgeImage: null,
    Icon: RiOpenaiFill,
    url: 'https://academy.openai.com/public/certificate/tc9rxyhi8d',
  },
  {
    id: 'fast-nuces-cs',
    title: 'BS in Computer Science (Silver Medalist)',
    year: '2011–2015',
    issuer: 'National University of Computer & Emerging Sciences (FAST)',
    detail: 'Grade A · 1× Rector’s List, 5× Dean’s List · Web Designer at ACM',
    credentialId: null,
    badgeImage: null,
    Icon: LuAward,
    url: null,
  },
];

// Shared sections below the switch adapt to the chosen track.
const trackContent = {
  teach: {
    bridge: <>The best training comes from <em>building.</em></>,
    figures: [
      ['10+', 'Years building technology'],
      ['4', 'Programmes for teams & leaders'],
      ['6', 'Products built, used as live examples'],
      ['3', 'Step HRD Corp training flow'],
    ],
    profileImage: profilePortrait,
    profileAlt: 'Usama Noman speaking on stage about AI',
    profileKicker: 'Profile of the Accredited Trainer & Founder',
    profileRolePrimary: 'HRD Corp Accredited Trainer · Corporate AI Speaker',
    profileRoleSecondary: 'Founder & Chief Executive Officer, Dotomat Sdn. Bhd.',
    profileTitle: 'An accredited trainer who builds AI products.',
    profileLead: 'Usama Noman is an HRD Corp Accredited Trainer and Founder & Chief Executive Officer of Dotomat Sdn. Bhd. who helps organisations across Malaysia and beyond adopt AI, ChatGPT, Claude and agentic workflows in their daily operations.',
    profileBody: 'Over the past decade he has founded multiple AI and SaaS products, including Botsify (featured in Product Hunt, VentureBeat and Tech in Asia), ReachOwl, Dotomat and WarmupYourEmail (acquired by Mailshake), bringing real product-building experience to every training room.',
    roles: 'HRD Corp Accredited Trainer · Speaker · Founder',
    focus: 'Corporate AI training, generative AI workflows, AI agents for teams',
    mediaEyebrow: 'Training sessions',
    mediaTitle: 'Recent corporate workshops & training.',
    close: [
      { label: 'For organisations', title: 'Plan a training', href: trainingEnquiry },
      { label: 'For events & conferences', title: 'Invite to speak', href: speakingEnquiry },
    ],
  },
  build: {
    bridge: <>The best systems work because people <em>understand them.</em></>,
    figures: [
      ['10+', 'Years building technology'],
      ['6', 'Products founded & built'],
      ['6', 'Automations shown on video'],
      ['4', 'Step implementation process'],
    ],
    profileImage: profilePortrait,
    profileAlt: 'Usama Noman presenting on stage',
    profileKicker: 'Profile of the Founder & AI Consultant',
    profileRolePrimary: 'Founder & Chief Executive Officer, Dotomat Sdn. Bhd.',
    profileRoleSecondary: 'AI & Workflow Automation Consultant · HRD Corp Accredited Trainer',
    profileTitle: 'A founder who builds production AI systems.',
    profileLead: 'Usama Noman is the Founder & Chief Executive Officer of Dotomat Sdn. Bhd. and an AI & Automation Consultant who builds conversational AI, voice agents and multi-step workflow systems for growing businesses.',
    profileBody: 'Since founding Botsify following the launch of Messenger chatbots at Facebook F8, he has built and scaled six SaaS products, including WarmupYourEmail (sold to Mailshake), ReachOwl, Vocallify and Dotomat, combining full-stack engineering with practical business automation.',
    roles: 'Founder · Full-stack developer · AI consultant',
    focus: 'AI agents, workflow automation, custom integrations',
    mediaEyebrow: 'Automations in action',
    mediaTitle: 'Live AI agents & workflow automations.',
    close: [
      {
        label: 'For businesses · 30-Min Strategy Session',
        title: 'Book a consulting call',
        href: consultingCall,
        description:
          'A focused 1-on-1 discovery call with Usama Noman to review your current operations, pinpoint repetitive bottlenecks, and map out the right AI agent and workflow architecture for your team.',
        points: [
          '1-on-1 Workflow & Bottleneck Audit',
          'AI Agent & Integration Blueprint',
          'Clear Implementation & ROI Roadmap',
        ],
      },
    ],
  },
};

function Process({ steps }) {
  return (
    <ol className="tt-process">
      {steps.map(([title, text], i) => (
        <li key={title}>
          <span className="tt-process-no">{String(i + 1).padStart(2, '0')}</span>
          <h4>{title}</h4>
          <p>{text}</p>
        </li>
      ))}
    </ol>
  );
}

export default function Home() {
  const [track, setTrack] = useState(() => (typeof window !== 'undefined' && window.location.hash === '#consulting' ? 'build' : 'teach'));

  const choose = (next, scroll = true) => {
    setTrack(next);
    if (scroll) {
      requestAnimationFrame(() => document.getElementById('tracks')?.scrollIntoView({ behavior: 'smooth' }));
    }
  };

  useEffect(() => {
    const onHash = () => {
      if (window.location.hash === '#consulting') choose('build');
      if (window.location.hash === '#training') choose('teach');
    };
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const current = tracks[track];
  const shared = trackContent[track];

  return (
    <div className={`tt-page is-${track}`} id="top">
      {/* Header */}
      <header className="tt-header">
        <div className="tt-wrap tt-header-inner">
          <a href="#top" className="tt-brand">
            <span className="tt-brand-dot" aria-hidden="true" />
            Usama Noman
          </a>
          <nav className="tt-nav" aria-label="Primary navigation">
            <a href="#worked-with">Companies</a>
            <a href="#media">Media</a>
          </nav>
          <a
            className="tt-btn tt-btn-accent tt-btn-sm"
            href={current.href}
            {...(current.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          >
            <span className="tt-hide-xs">{current.cta}</span><span className="tt-show-xs">Enquire</span>
          </a>
        </div>
      </header>

      <main>
        {/* Two-track hero */}
        <section className="tt-hero" aria-label="Introduction">
          <button type="button" className="tt-half tt-half-teach" onClick={() => choose('teach')} aria-label="Show training and speaking">
            <span className="tt-half-index">01 · I train</span>
            <span className="tt-half-title">Teams that use AI <em>with confidence.</em></span>
            <span className="tt-half-copy">AI training and talks for organisations in Malaysia and beyond.</span>
            <span className="tt-half-footer">
              <span className="tt-half-cta">For organisations <FiArrowRight /></span>
              <span className="tt-half-float">
                {teachFloatingTools.map(({ name, Icon, color, href }, i) => (
                  <span
                    key={name}
                    title={name}
                    aria-label={name}
                    className={`tt-float-pill${href ? ' is-link' : ''}`}
                    style={{ '--i': i, '--icon-color': color }}
                    {...(href
                      ? {
                          role: 'link',
                          tabIndex: 0,
                          onClick: (e) => {
                            e.stopPropagation();
                            window.open(href, '_blank', 'noopener,noreferrer');
                          },
                          onKeyDown: (e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.stopPropagation();
                              window.open(href, '_blank', 'noopener,noreferrer');
                            }
                          },
                        }
                      : { 'aria-hidden': 'true' })}
                  >
                    <Icon />
                  </span>
                ))}
              </span>
            </span>
          </button>

          <figure className="tt-hero-portrait">
            <div className="tt-portrait-ring">
              <img src={heroPortrait} alt="Usama Noman" />
            </div>
            <figcaption>
              <img
                src={track === 'teach' ? hrdBadge : dotomatLogo}
                alt={track === 'teach' ? 'HRD Corp Accredited Trainer badge' : 'Dotomat logo'}
                className={`tt-hrd-seal${track === 'build' ? ' is-dotomat' : ''}`}
              />
              <div className="tt-figcaption-text">
                <strong>Usama Noman</strong>
                <span>
                  {track === 'teach' ? (
                    <>
                      <b className="tt-role-active">HRD Corp Accredited Trainer</b> · Founder · AI consultant
                    </>
                  ) : (
                    <>
                      <b className="tt-role-active">Founder · AI consultant</b> · HRD Corp Accredited Trainer
                    </>
                  )}
                </span>
              </div>
            </figcaption>
          </figure>

          <button type="button" className="tt-half tt-half-build" onClick={() => choose('build')} aria-label="Show consulting and automation">
            <span className="tt-half-index">02 · I build</span>
            <span className="tt-half-title">Systems that remove <em>repetitive work.</em></span>
            <span className="tt-half-copy">AI agents and automation designed around how your business actually runs.</span>
            <span className="tt-half-footer">
              <span className="tt-half-float">
                {buildFloatingTools.map(({ name, Icon, color, href }, i) => (
                  <span
                    key={name}
                    title={name}
                    aria-label={name}
                    className={`tt-float-pill${href ? ' is-link' : ''}`}
                    style={{ '--i': i, '--icon-color': color }}
                    {...(href
                      ? {
                          role: 'link',
                          tabIndex: 0,
                          onClick: (e) => {
                            e.stopPropagation();
                            if (href.startsWith('mailto:')) {
                              window.location.href = href;
                            } else {
                              window.open(href, '_blank', 'noopener,noreferrer');
                            }
                          },
                          onKeyDown: (e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.stopPropagation();
                              if (href.startsWith('mailto:')) {
                                window.location.href = href;
                              } else {
                                window.open(href, '_blank', 'noopener,noreferrer');
                              }
                            }
                          },
                        }
                      : { 'aria-hidden': 'true' })}
                  >
                    <Icon />
                  </span>
                ))}
              </span>
              <span className="tt-half-cta">For businesses <FiArrowRight /></span>
            </span>
          </button>
        </section>

        {/* Track switch */}
        <div className="tt-switch-bar" id="tracks">
          <div className="tt-wrap tt-switch-inner">
            <span className="tt-switch-label">Show me</span>
            <div className="tt-switch" role="tablist" aria-label="Choose a track">
              <span className="tt-switch-thumb" aria-hidden="true" />
              {Object.entries(tracks).map(([key, t]) => (
                <button
                  key={key}
                  type="button"
                  role="tab"
                  aria-selected={track === key}
                  aria-controls={`panel-${key}`}
                  className={track === key ? 'is-active' : ''}
                  onClick={() => choose(key, false)}
                >
                  <span className="tt-hide-xs">{t.label}</span><span className="tt-show-xs">{t.short}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Training track */}
        <section id="panel-teach" role="tabpanel" hidden={track !== 'teach'} className="tt-panel tt-panel-teach">
          <div className="tt-wrap">
            <div className="tt-panel-intro">
              <p className="tt-eyebrow">Training &amp; Speaking</p>
              <h2>Practical AI training for <mark>real business work.</mark></h2>
              <p className="tt-lead">Hands-on corporate training that equips your team to use AI tools, agents and workflows with clarity and measurable impact.</p>
            </div>

            <figure className="tt-panel-photo">
              <img src={workshopPhoto} alt="Usama Noman with corporate training participants at the Mastering Claude AI for Workspace Productivity workshop" loading="lazy" width="1024" height="576" />
              <figcaption>Hands-on sessions: participants apply AI to their own work, with guidance at every table.</figcaption>
            </figure>

            <div className="tt-outcomes">
              {teachOutcomes.map(([title, text]) => (
                <div key={title}>
                  <FiCheck aria-hidden="true" />
                  <h3>{title}</h3>
                  <p>{text}</p>
                </div>
              ))}
            </div>

            <div className="tt-block">
              <div className="tt-block-side">
                <h3>Programmes</h3>
                <p>Four starting points, each shaped around your team.</p>
              </div>
              <div className="tt-table">
                {programmes.map((p) => (
                  <div className="tt-table-row" key={p.no}>
                    <span className="tt-table-no">{p.no}</span>
                    <div>
                      <h4>{p.title}</h4>
                      <p>{p.outcome}</p>
                    </div>
                    <span className="tt-table-tag">{p.audience}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="tt-block">
              <div className="tt-block-side">
                <h3>How it works</h3>
                <p>From first conversation to lasting habits.</p>
              </div>
              <Process steps={teachProcess} />
            </div>

            <div className="tt-panel-cta">
              <p>Planning AI training for your team, or looking for a speaker?</p>
              <div className="tt-actions">
                <a href={trainingEnquiry} target="_blank" rel="noopener noreferrer" className="tt-btn tt-btn-accent">Discuss a training <FiArrowUpRight /></a>
              </div>
            </div>
          </div>
        </section>

        {/* Consulting track */}
        <section id="panel-build" role="tabpanel" hidden={track !== 'build'} className="tt-panel tt-panel-build">
          <div className="tt-wrap">
            <div className="tt-panel-intro">
              <p className="tt-eyebrow">Consulting &amp; Automation</p>
              <h2>Custom AI automation for <mark>growing businesses.</mark></h2>
              <p className="tt-lead">I identify where manual work slows your operations down, connect the tools you already use and build AI agents and workflows that run reliably in production.</p>
            </div>

            <div className="tt-block">
              <div className="tt-block-side">
                <h3>What gets automated</h3>
                <p>Typical work that moves from people to systems.</p>
              </div>
              <ul className="tt-chips">
                {buildExamples.map((item) => <li key={item}>{item}</li>)}
              </ul>
            </div>

            <div className="tt-block">
              <div className="tt-block-side">
                <h3>The process</h3>
                <p>Four steps from friction to a working system.</p>
              </div>
              <Process steps={buildProcess} />
            </div>

            <div className="tt-panel-cta">
              <p>Have repetitive work that should run itself?</p>
              <div className="tt-actions">
                <a href={consultingCall} target="_blank" rel="noopener noreferrer" className="tt-btn tt-btn-accent">Book a consulting call <FiArrowUpRight /></a>
                <a href="#media" className="tt-btn tt-btn-line">See automations in action</a>
              </div>
            </div>
          </div>
        </section>

        {/* Bridge */}
        <section className="tt-bridge tt-bridge-single" aria-label="Approach">
          <div className={`tt-bridge-half tt-bridge-${track}`}>
            <p>{shared.bridge}</p>
          </div>
        </section>

        {/* Key figures */}
        <section className="tt-figures" aria-label="Key figures">
          <div className="tt-wrap">
            <dl>
              {shared.figures.map(([value, label]) => (
                <div key={label}><dt>{value}</dt><dd>{label}</dd></div>
              ))}
            </dl>
          </div>
        </section>

        {/* Companies & projects logo wall */}
        <LogoWall track={track} />

        {/* Profile — Sticky portrait left + scrollable portfolio right */}
        <section className="tt-profile" id="profile" aria-labelledby="profile-title">
          <div className="tt-wrap tt-profile-grid">
            <aside className="tt-profile-sticky">
              <div className={`tt-profile-photo is-${track}`}>
                <img src={shared.profileImage} alt={shared.profileAlt} loading="lazy" />
              </div>
              <div className="tt-profile-quick">
                <a
                  href={socialUrls.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tt-profile-social-pill"
                  title="LinkedIn"
                  aria-label="LinkedIn"
                  style={{ '--icon-color': '#0A66C2' }}
                >
                  <FaLinkedinIn aria-hidden="true" />
                </a>
                <a
                  href={socialUrls.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tt-profile-social-pill"
                  title="YouTube"
                  aria-label="YouTube"
                  style={{ '--icon-color': '#FF0000' }}
                >
                  <SiYoutube aria-hidden="true" />
                </a>
                <a
                  href={socialUrls.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tt-profile-social-pill"
                  title="Facebook"
                  aria-label="Facebook"
                  style={{ '--icon-color': '#1877F2' }}
                >
                  <SiFacebook aria-hidden="true" />
                </a>
                <a
                  href={socialUrls.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tt-profile-social-pill"
                  title="Instagram"
                  aria-label="Instagram"
                  style={{ '--icon-color': '#E4405F' }}
                >
                  <SiInstagram aria-hidden="true" />
                </a>
                <a
                  href={socialUrls.email}
                  className="tt-profile-social-pill"
                  title="Email"
                  aria-label="Email"
                  style={{ '--icon-color': '#0284C7' }}
                >
                  <FiMail aria-hidden="true" />
                </a>
              </div>
            </aside>

            <div className="tt-profile-portfolio">
              {/* 1. Executive Bio & Intro */}
              <div className="tt-portfolio-intro">
                <p className="tt-portfolio-kicker">{shared.profileKicker}</p>
                <h2 id="profile-title" className="tt-portfolio-name">Usama Noman</h2>
                <p className="tt-portfolio-role-primary">{shared.profileRolePrimary}</p>
                <p className="tt-portfolio-role-secondary">{shared.profileRoleSecondary}</p>
                <p className="tt-portfolio-location">Federal Territory of Kuala Lumpur, Malaysia</p>

                <p className="tt-profile-lead">{shared.profileLead}</p>
                <p className="tt-profile-body">{shared.profileBody}</p>
              </div>

              {/* 2. Experience Timeline Table */}
              <div className="tt-portfolio-block">
                <h3 className="tt-portfolio-heading">Experience</h3>
                <div className="tt-exp-table" role="table" aria-label="Professional experience">
                  <div className="tt-exp-head" role="row">
                    <span role="columnheader">Years</span>
                    <span role="columnheader">Organisation</span>
                    <span role="columnheader">Role</span>
                  </div>
                  {experienceItems.map((item) => {
                    const OrgTag = item.url ? 'a' : 'div';
                    const orgProps = item.url
                      ? { href: item.url, target: '_blank', rel: 'noopener noreferrer' }
                      : {};
                    return (
                      <div className="tt-exp-row" role="row" key={`${item.org}-${item.years}`}>
                        <div className="tt-exp-years" role="cell">{item.years}</div>
                        <div className="tt-exp-org" role="cell">
                          <OrgTag className="tt-exp-org-inner" {...orgProps}>
                            <span className="tt-exp-logo" aria-hidden="true">
                              {item.logo ? (
                                <img src={item.logo} alt="" loading="lazy" />
                              ) : (
                                <span>{item.monogram}</span>
                              )}
                            </span>
                            <div>
                              <strong>{item.org}</strong>
                              <span>{item.location}</span>
                            </div>
                          </OrgTag>
                        </div>
                        <div className="tt-exp-role" role="cell">
                          <strong>{item.role}</strong>
                          <p>{item.detail}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* 3. Certifications & Accreditations */}
              <div className="tt-portfolio-block">
                <h3 className="tt-portfolio-heading">Certifications &amp; Accreditations</h3>
                <div className="tt-cert-grid">
                  {certifications.map((cert) => {
                    const CertIcon = cert.Icon;
                    return (
                      <article className="tt-cert-card" key={cert.id}>
                        <div className="tt-cert-badge">
                          {cert.badgeImage ? (
                            <img src={cert.badgeImage} alt={cert.title} className="tt-cert-seal" />
                          ) : (
                            <span className="tt-cert-icon" aria-hidden="true">
                              <CertIcon />
                            </span>
                          )}
                        </div>
                        <div className="tt-cert-body">
                          <div className="tt-cert-title-row">
                            <h4>{cert.title}</h4>
                            <span className="tt-cert-year">{cert.year}</span>
                          </div>
                          <p className="tt-cert-issuer">{cert.issuer}</p>
                          <p className="tt-cert-detail">{cert.detail}</p>
                          {cert.credentialId && (
                            <p className="tt-cert-id">{cert.credentialId}</p>
                          )}
                          {cert.url && (
                            <a
                              href={cert.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="tt-cert-verify"
                            >
                              Verify credential <FiArrowUpRight />
                            </a>
                          )}
                        </div>
                      </article>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Media / Training sessions */}
        <section className="tt-media" id="media" aria-labelledby="media-title">
          <div className="tt-wrap">
            <div className="tt-media-head">
              <div>
                <p className="tt-eyebrow">{shared.mediaEyebrow}</p>
                <h2 id="media-title">{shared.mediaTitle}</h2>
              </div>
              {track === 'teach' ? (
                <a href={trainingEnquiry} target="_blank" rel="noopener noreferrer" className="tt-link">Book a training session <FiArrowUpRight /></a>
              ) : (
                <a href={youtubeChannel} target="_blank" rel="noopener noreferrer" className="tt-link">All videos on YouTube <FiArrowUpRight /></a>
              )}
            </div>
            <MediaLibrary track={track} />
          </div>
        </section>

        {/* Closing split */}
        <section className={`tt-close${shared.close.length === 1 ? ' tt-close-single' : ''}`} aria-label="Get in touch">
          {shared.close.map((item, i) => {
            const external = item.href.startsWith('http');
            return (
              <a
                key={item.title}
                href={item.href}
                className={`tt-close-half ${i === 0 ? 'tt-close-teach' : 'tt-close-build'}`}
                {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              >
                <div className="tt-close-main">
                  <span className="tt-close-eyebrow">{item.label}</span>
                  <strong>{item.title}</strong>
                </div>
                {item.description && (
                  <div className="tt-close-details">
                    <p>{item.description}</p>
                    {item.points && (
                      <ul className="tt-close-points">
                        {item.points.map((pt) => (
                          <li key={pt}>
                            <FiCheck aria-hidden="true" />
                            <span>{pt}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
                {external ? (
                  <FiArrowUpRight className="tt-close-arrow" aria-hidden="true" />
                ) : (
                  <FiArrowRight className="tt-close-arrow" aria-hidden="true" />
                )}
              </a>
            );
          })}
        </section>

      </main>

      <Footer track={track} />
    </div>
  );
}
